import classNames from 'classnames';
import React from 'react';
import { SKELETON } from '../../constants/dataTestIds';
import { getDataTestAttrs } from '../../utils/testing-locators';
import styles from './styles.module.css';

const Skeleton = ({ className }) => (
  <i
    className={classNames(styles.component, className)}
    {...getDataTestAttrs(SKELETON)}
  />
);

export default Skeleton;
